import * as ActionConfigurationManager from './config.actions';

export const saveReferenceID = ActionConfigurationManager.SAVE_REF_ID
export const resetReferenceID = ActionConfigurationManager.RESET_REF_ID